import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import WeekIntroPage from "./WeekIntroPage";
import { API_BASE_URL } from "../config/apiBase";
import { getAuthUserHeader } from "../utils/userRoles";

export default function WeekStartPage() {
  const { studentId, weekId } = useParams();
  const week = Number(weekId);
  const navigate = useNavigate();
  const [intro, setIntro] = React.useState(null);
  const [error, setError] = React.useState("");
  const [starting, setStarting] = React.useState(false);

  React.useEffect(() => {
    if (!studentId || !Number.isInteger(week) || week < 1 || week > 4) return undefined;
    let cancelled = false;
    fetch(`${API_BASE_URL}/api/week-intro/state?student_id=${encodeURIComponent(studentId)}&week=${week}`, {
      headers: { "X-User": getAuthUserHeader() },
    })
      .then((response) => response.json().then((data) => ({ response, data })))
      .then(({ response, data }) => {
        if (cancelled) return;
        if (!response.ok) throw new Error("intro_failed");
        setIntro(data.week_intro || null);
      })
      .catch(() => { if (!cancelled) setError("Could not load the Week start page."); });
    return () => { cancelled = true; };
  }, [studentId, week]);

  const startWeek = async () => {
    setStarting(true); setError("");
    try {
      const response = await fetch(`${API_BASE_URL}/api/week-intro/complete?student_id=${encodeURIComponent(studentId)}&week=${week}`, {
        method: "POST", headers: { "X-User": getAuthUserHeader() },
      });
      if (!response.ok) throw new Error("start_failed");
      navigate(`/student/${studentId}/week/${week}/lesson/1`);
    } catch { setError("Could not start this week. Please try again."); } finally { setStarting(false); }
  };

  if (!studentId || !Number.isInteger(week) || week < 1 || week > 4) return <main className="week-intro-page"><p>Invalid week.</p></main>;
  return <main><WeekIntroPage weekNumber={week} weekIntro={intro} onStartWeek={startWeek} starting={starting} />{error ? <p role="alert">{error}</p> : null}</main>;
}
